import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import flatten from 'lodash.flatten';
import { IMAGE_ID, URL, ID } from '../../constants';
const getPropValues = properties => properties.reduce((acc, property) => {
  if (property.includes('.')) {
    const [relationName, relationProp] = property.split('.');
    return `${acc} ${relationName} { ${relationProp} }`;
  }
  return `${acc} ${property}`;
}, '').trim();
const getUpdatedPropsQuery = (propsQuery, entityData) => {
  const {
    properties = {},
    dynamicProperties = {}
  } = entityData;
  const [url] = Object.keys(dynamicProperties).filter(prop => prop === URL);
  const hasImage = !!Object.keys(properties).filter(prop => prop === IMAGE_ID).length;
  let updatedPropsQuery = hasImage ? `${propsQuery} ${IMAGE_ID}` : propsQuery;
  updatedPropsQuery = url ? `${updatedPropsQuery} ${URL}` : updatedPropsQuery;
  return updatedPropsQuery;
};
const buildFilterQueryString = filter => {
  const [filterKey, filterValue] = filter.split('/');
  const filterKeyword = `${filterKey}.keyword`;
  return {
    bool: {
      should: [{
        match: {
          [filterKeyword]: filterValue
        }
      }]
    }
  };
};
const buildFilters = filters => {
  if (!filters || !filters.length) return null;
  const filterQueryProps = filters.map(buildFilterQueryString);
  return {
    bool: {
      should: filterQueryProps
    }
  };
};
const buiildShapeProps = (shape, shapeKey, dataSummaries, parentId, entityData, entityGroup) => {
  const {
    displayItems = [],
    filterBy
  } = shape;
  const {
    latProp,
    lonProp,
    entity
  } = entityGroup;
  const {
    actions,
    relations
  } = entityData;
  const action = actions ? actions.getAllPublished || actions.getAll : '';
  const dataSummaryProps = dataSummaries.reduce((acc, {
    propsToDisplay
  }) => {
    const propsToDisplayValues = flatten(propsToDisplay.map(({
      propertiesToDisplay
    }) => propertiesToDisplay));
    const propsToDisplayString = getPropValues(propsToDisplayValues);
    return `${acc} ${propsToDisplayString}`;
  }, '').trim();
  const ids = [];
  displayItems.length ? ids.push(displayItems[0]) : ids.push(parentId);
  const filtersObject = buildFilters(filterBy);
  let propsQuery = dataSummaryProps ? `${dataSummaryProps}` : '';
  propsQuery = getUpdatedPropsQuery(propsQuery, entityData);
  if (latProp && lonProp) {
    propsQuery = `${propsQuery} ${formatProp(latProp, relations)} ${formatProp(lonProp, relations)}`;
  }
  if (ids.length && !propsQuery.includes(ID)) propsQuery = `${propsQuery.trim()} ${ID}`;
  return {
    shapeKey,
    entity,
    propsQuery,
    ids,
    action,
    filtersObject
  };
};
const formatProp = (prop, relations = []) => {
  if (!prop.includes('.')) return prop;
  const [mainProp, nestedProp] = prop.split('.');
  const idProp = relations.find(({
    localField
  }) => localField === mainProp) ? 'id ' : '';
  return `${mainProp}{${idProp}${nestedProp}}`;
};
const buildShapesConfig = (schemas, entityGroups, parent) => {
  if (!schemas || !entityGroups) return [];
  const {
    itemId,
    itemEntity
  } = parent;
  const shapeGroups = [];
  entityGroups.forEach((entityGroup, i) => {
    const {
      entity,
      shapes,
      dataSummaries = []
    } = entityGroup;
    const parentId = entity === itemEntity && itemId;
    if (!entity) return null;
    const entityData = schemas[entity] || {};
    shapes.filter(Boolean).forEach((shape, shapeIndex) => {
      const shapeKey = `shape${i}${shapeIndex}`;
      const shapeValues = buiildShapeProps(shape, shapeKey, dataSummaries, parentId, entityData, entityGroup);
      shapeGroups.push(_objectSpread(_objectSpread({}, shapeValues), {}, {
        shapeOptions: shape,
        entityOptions: entityGroup
      }));
    });
  });
  return shapeGroups;
};
export default buildShapesConfig;
//# sourceMappingURL=build-shapes-configs.js.map